import { createApp } from 'vue'
import App from './App.vue'
import router from './router/index'
import { createPinia } from 'pinia'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import DownloadCsv from 'vue-json-csv'

// Load fonts
loadFonts()

// Create pinia store
const pinia = createPinia()

// Create app
const app = createApp(App)

// Register global components
app.component('download-csv', DownloadCsv)

// Use plugins
app.use(pinia)
app.use(router)
app.use(vuetify)

// Initialize auth store and then mount app
// This ensures the router guard has the auth state before initial navigation
import { useAuthStore } from '@/store/auth'
const authStore = useAuthStore()

authStore.init().then(() => {
  app.mount('#app')
})